import { ExportPostsReviewToggleForm } from "./export-posts-review-toggle-form";
import { ExportPostsReviewToggleHandler } from "./export-posts-review-toggle-handler";
import { ExportPostsReviewToggleListener } from "./export-posts-review-toggle-listener";

export class ExportPostsReviewToggleSetup {
    public static init(root: HTMLElement): void {
        if (root.dataset.exportPostsReviewToggleInit === "1") return;
        root.dataset.exportPostsReviewToggleInit = "1";

        const form = new ExportPostsReviewToggleForm(root);
        const select = form.getBoardIdSelect();
        const field = form.getReviewQuestionsField();
        if (!select || !field) return;

        const handler = new ExportPostsReviewToggleHandler();
        handler.applyVisibility(select, field);

        const listener = new ExportPostsReviewToggleListener(handler);
        listener.register(select, field);
    }
}
